import styled from 'styled-components'
import theme from 'theme_'

import { WhiteBlock } from 'components/Layout'

export const AuditContainer = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  min-height: 80vh;

  > div {
    width: 100%;
  }
`

export const AuditBody = styled.div`
  padding: 12px;
  @media ${theme.devices.tablet} {
    padding: ${theme.spacing.base} ${theme.spacing.xxl};
  }
`
export const AuditWhiteCard = styled(WhiteBlock)`
  width: 100%;
  gap: 15px;
`
export const AuditMobileTableAction = styled.div`
  text-transform: capitalize;
  font-size: 14px;
`

export const AuditMobileTableDataContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
`

export const AuditMobileTableTitle = styled.div`
  color: ${theme.colors.darkeyGrey};
`

export const AuditMobileTableLabel = styled.div`
  font-size: 14px;
`

export const AuditSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`
